(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('HAHA landing: GSAP not loaded');
      initWithoutGsap();
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    initLanding();
  });

  function loadImageMap() {
    var el = document.getElementById('hahaLandingImages');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  var IMAGE_MAP = {};

  var MODELS = {
    mini: {
      name: 'Mini 360',
      kicker: 'SMALL SPACE SOLUTION',
      tagline: 'Small footprint. Full AI power.',
      price: '$2,999',
      capacity: '216+',
      shelves: '6',
      cameras: '2',
      desc: 'A compact AI cooler built for small spaces with the complete HAHA smart retail experience.',
      locations: 'Ideal for compact spaces where smart retail needs to fit into every corner. Great for offices, apartments, boutique gyms, cafes, and other space-limited locations.',
      productUrl: '/products/haha-ai-vending-mini-360-touch-card-reader-smart-refrigerated-combo-with-216-bottles-space',
      checkoutUrl: '/cart/46810169737464:1?checkout'
    },
    plus: {
      name: 'Plus 440',
      kicker: 'FLEXIBLE RETAIL SOLUTION',
      tagline: 'More capacity. More possibilities.',
      price: '$3,799',
      capacity: '288+',
      shelves: '6',
      cameras: '2',
      desc: 'A flexible AI cooler designed for growing locations that need more product variety while keeping a compact footprint.',
      locations: 'Built for locations that need a wider product selection and more daily sales capacity. Great for workplaces, fitness centers, hotels, retail spaces, and other high-frequency customer areas.',
      productUrl: '/products/haha-ai-vending-plus-440-pos-nfc-beverage-focus-smart-refrigerated-with-288-bottles-space',
      checkoutUrl: '/cart/46081729888504:1?checkout'
    },
    pro: {
      name: 'Pro 542',
      kicker: 'PROFESSIONAL RETAIL SOLUTION',
      tagline: 'Built for serious operators.',
      price: '$4,999',
      capacity: '324+',
      shelves: '6',
      cameras: '2',
      desc: 'Full AI power, larger capacity, and reliable performance for high-traffic locations.',
      locations: 'Designed for locations with consistent customer traffic and a wider range of product needs. Great for gyms, hotels, schools, workplaces, and other professional retail environments.',
      productUrl: '/products/haha-ai-vending-pro-542-cashless-24-7-grab-go-vending-with-324-bottles-space',
      checkoutUrl: '/cart/46081755775224:1?checkout'
    },
    freezer: {
      name: 'Freezer 550',
      kicker: 'FROZEN RETAIL SOLUTION',
      tagline: 'Cold storage meets smart retail.',
      price: '$5,399',
      capacity: '336+',
      shelves: '6',
      cameras: '2',
      desc: 'Built for frozen products with AI-powered vending convenience.',
      locations: 'Designed for frozen products that require reliable temperature control and automated retail access. Great for ice cream, frozen meals, prepared foods, and locations looking to expand beyond traditional vending products.',
      productUrl: '/products/haha-ai-vending-freezer-550-pos-nfc-flexi-temp-with-336-bottles-space-1',
      checkoutUrl: '/cart/47408022749432:1?checkout'
    },
    max620s: {
      name: 'Max 620S',
      kicker: 'SMART DISPLAY SOLUTION',
      tagline: 'Turn every location into a smart retail experience.',
      price: '$5,399',
      capacity: '378+',
      shelves: '6',
      cameras: '2',
      desc: 'A large display, advanced AI, and premium product visibility.',
      locations: 'Designed for locations where visibility and customer engagement matter as much as sales. Great for malls, airports, hotels, campuses, and premium commercial spaces.',
      productUrl: '/products/haha-ai-vending-max-620-cashless-smart-refrigerated-combo-with-378-bottles-spaces',
      checkoutUrl: '/cart/47966077911288:1?checkout'
    },
    max660: {
      name: 'Max 660',
      kicker: 'HIGH CAPACITY SOLUTION',
      tagline: 'More products. More flexibility.',
      price: '$5,499',
      capacity: '432+',
      shelves: '6',
      cameras: '2',
      desc: 'A high-capacity AI cooler designed for locations that need greater inventory space and efficient daily operations.',
      locations: 'Designed for high-demand locations that need more product choices and fewer restocking trips. Great for factories, large offices, campuses, gyms, and busy commercial locations.',
      productUrl: '/products/haha-ai-vending-max-660',
      checkoutUrl: '/cart/48820819755256:1?checkout'
    },
    ultra: {
      name: 'Ultra 1200',
      kicker: 'LARGE SCALE RETAIL SOLUTION',
      tagline: 'Maximum capacity. Full AI retail power.',
      price: '$7,299',
      capacity: '648+',
      shelves: '12',
      cameras: '4',
      desc: 'A large-scale AI cooler built for high-traffic locations that need more products, more availability, and fewer restocking trips.',
      locations: 'Designed for large spaces with high customer flow and greater product demands. Great for airports, factories, universities, transportation hubs, large offices, and other high-traffic locations.',
      productUrl: '/products/haha-ai-vending-ultra-1200-pos-nfc-self-service-double-door-refrigerated-with-648-bottles-space',
      checkoutUrl: '/cart/46810356482296:1?checkout'
    }
  };

  var currentModel = 'pro';

  function clearHotspotActive() {
    document.querySelectorAll('.family-hotspot').forEach(function (h) {
      h.classList.remove('family-hotspot--active');
    });
  }

  function setAllPillActive() {
    document.querySelectorAll('.selector-pill').forEach(function (p) {
      p.classList.toggle('selector-pill--active', p.dataset.model === 'all');
    });
  }

  function initWithoutGsap() {
    IMAGE_MAP = loadImageMap();
    wireInteractions(false);
    initFaq();
    initModal();
    initDemoVideo();
    renderDetail('pro', true);
    pauseScanlineOnScroll();
  }

  function initLanding() {
    IMAGE_MAP = loadImageMap();
    wireInteractions(true);
    initFaq();
    initModal();
    initDemoVideo();
    renderDetail('pro', true);
    initAnimations();
  }

  function initDemoVideo() {
    var section = document.getElementById('customerExperience');
    var video = document.getElementById('demoVideo');
    var btn = document.getElementById('demoPlayBtn');
    if (!section || !video || !btn) return;

    video.pause();
    video.removeAttribute('autoplay');

    btn.addEventListener('click', function () {
      var enterFs =
        video.requestFullscreen ||
        video.webkitRequestFullscreen ||
        video.webkitEnterFullscreen ||
        video.msRequestFullscreen;

      video.muted = false;
      video.loop = false;
      section.classList.add('is-playing');
      btn.textContent = 'PLAYING…';

      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            if (enterFs) {
              try {
                enterFs.call(video);
              } catch (e) {}
            }
          })
          .catch(function () {
            video.muted = true;
            video.play();
          });
      } else if (enterFs) {
        try {
          enterFs.call(video);
        } catch (e) {}
      }
    });

    video.addEventListener('ended', function () {
      section.classList.remove('is-playing');
      btn.textContent = 'PLAY FULL DEMO';
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(function () {});
      }
    });

    function onFsChange() {
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (!fsEl) {
        section.classList.remove('is-playing');
        btn.textContent = 'PLAY FULL DEMO';
        video.pause();
        video.currentTime = 0;
        video.muted = true;
      }
    }
    document.addEventListener('fullscreenchange', onFsChange);
    document.addEventListener('webkitfullscreenchange', onFsChange);
  }

  function wireInteractions(withGsap) {
    var allPill = document.querySelector('.selector-pill[data-model="all"]');
    if (allPill) {
      allPill.addEventListener('click', function (e) {
        e.preventDefault();
        showView('all', null, withGsap);
      });
    }

    var hotspots = document.getElementById('familyHotspots');
    if (hotspots) {
      hotspots.addEventListener('click', function (e) {
        var h = e.target.closest('.family-hotspot');
        if (!h) return;
        e.preventDefault();
        // Temporarily disable machine click → detail view jump; restore later:
        // showView('detail', h.getAttribute('data-model'), withGsap);
      });
    }

    var back = document.querySelector('.detail-view__back');
    if (back) {
      back.addEventListener('click', function () {
        showView('all', null, withGsap);
      });
    }
  }

  function showView(view, model, withGsap) {
    var vAll = document.getElementById('viewAll');
    var vDet = document.getElementById('viewDetail');
    clearHotspotActive();

    if (view === 'all') {
      var finishAll = function () {
        vDet.classList.add('view--hidden');
        vAll.classList.remove('view--hidden');
        setAllPillActive();
        clearHotspotActive();
        if (withGsap) {
          gsap.fromTo(vAll, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' });
        }
      };
      if (withGsap && !vDet.classList.contains('view--hidden')) {
        gsap.to(vDet, {
          opacity: 0,
          x: 40,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: finishAll
        });
      } else {
        finishAll();
      }
    } else {
      currentModel = model;
      renderDetail(model, false);
      var finishedDet = false;
      var finishDet = function () {
        if (finishedDet) return;
        finishedDet = true;
        vAll.classList.add('view--hidden');
        vAll.style.opacity = '';
        vAll.style.transform = '';
        vDet.classList.remove('view--hidden');
        setAllPillActive();
        clearHotspotActive();
        if (withGsap) {
          gsap.fromTo(vDet, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out' });
          gsap.fromTo(
            '#detailImg',
            { opacity: 0, scale: 0.92 },
            { opacity: 1, scale: 1, duration: 0.6, ease: 'power3.out', delay: 0.15 }
          );
          gsap.fromTo(
            '.detail-view__info > *',
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.5, stagger: 0.06, ease: 'power3.out', delay: 0.2 }
          );
        } else {
          vDet.style.opacity = '1';
        }
      };
      if (withGsap && !vAll.classList.contains('view--hidden')) {
        gsap.to(vAll, {
          opacity: 0,
          y: -30,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: finishDet
        });
        setTimeout(finishDet, 450);
      } else {
        finishDet();
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function renderDetail(key, silent) {
    var m = MODELS[key];
    if (!m) return;
    currentModel = key;
    var ghost = document.getElementById('ghostName');
    var kicker = document.getElementById('dKicker');
    var title = document.getElementById('dTitle');
    var tagline = document.getElementById('dTagline');
    var price = document.getElementById('dPrice');
    var desc = document.getElementById('dDesc');
    var locationsText = document.getElementById('dLocationsText');
    var detailImg = document.getElementById('detailImg');
    var stats = document.getElementById('dStats');
    var cta = document.getElementById('dCta');
    var compare = document.getElementById('dCompare');
    var interest = document.getElementById('leadInterestModel');
    var body = document.getElementById('leadBody');

    if (ghost) ghost.textContent = m.name.toUpperCase();
    if (kicker) kicker.textContent = '// ' + m.kicker;
    if (title) title.textContent = m.name;
    if (tagline) tagline.textContent = m.tagline;
    if (price) price.textContent = m.price;
    if (desc) desc.textContent = m.desc;
    if (locationsText) locationsText.textContent = m.locations;
    if (detailImg) {
      var src = IMAGE_MAP[key] || detailImg.getAttribute('src');
      if (src) detailImg.src = src;
      detailImg.alt = 'HAHA ' + m.name;
    }
    if (stats) {
      stats.innerHTML =
        '<div class="detail-view__stat"><div class="detail-view__stat-value">' +
        m.capacity +
        '</div><div class="detail-view__stat-label">Products</div></div>' +
        '<div class="detail-view__stat"><div class="detail-view__stat-value">' +
        m.shelves +
        '</div><div class="detail-view__stat-label">Shelves</div></div>' +
        '<div class="detail-view__stat"><div class="detail-view__stat-value">' +
        m.cameras +
        '</div><div class="detail-view__stat-label">AI Cameras</div></div>';
    }
    if (cta) {
      cta.href = m.checkoutUrl;
      cta.textContent = 'Buy Now';
    }
    if (compare) {
      compare.href = m.productUrl;
      compare.textContent = 'Compare Models';
    }
    if (interest) interest.value = m.name;
    if (body) body.value = 'Expert inquiry — ' + m.name + ' | Source: Landing experts';
  }

  function initModal() {
    var modal = document.getElementById('hahaLeadModal');
    if (!modal) return;
    var openers = document.querySelectorAll('[data-open-lead-modal]');
    var closers = modal.querySelectorAll('[data-close-lead-modal]');
    var target = document.getElementById('hahaLeadForms');

    function localizeFormsToEnglish(root) {
      if (!root) return;
      var map = {
        名字: 'Name',
        姓名: 'Name',
        名: 'First name',
        电子邮件: 'Email',
        电子邮箱: 'Email',
        邮箱: 'Email',
        电话号码: 'Phone number',
        手机号码: 'Phone number',
        手机号: 'Phone number',
        电话: 'Phone',
        公司名称: 'Company name',
        公司: 'Company',
        提交: 'Submit',
        必填: 'Required'
      };

      function swap(text) {
        if (!text) return text;
        var next = text;
        Object.keys(map).forEach(function (zh) {
          if (next.indexOf(zh) !== -1) next = next.split(zh).join(map[zh]);
        });
        return next;
      }

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var updated = swap(node.nodeValue);
        if (updated !== node.nodeValue) node.nodeValue = updated;
      }

      root.querySelectorAll('input, textarea, select, button, [placeholder], [aria-label]').forEach(function (el) {
        ['placeholder', 'aria-label', 'title', 'value'].forEach(function (attr) {
          if (!el.hasAttribute(attr)) return;
          if (attr === 'value' && el.tagName !== 'BUTTON' && el.type !== 'submit') return;
          var val = el.getAttribute(attr);
          var next = swap(val);
          if (next !== val) el.setAttribute(attr, next);
        });
      });

    }

    function moveFormsIntoModal() {
      if (!target) return false;
      var host = document.querySelector(
        '.haha-lead-forms-host .shopify-block, .haha-lead-forms-host [data-form-root], .haha-lead-forms-host .m-app-section__content'
      );
      if (host && !target.contains(host)) target.appendChild(host);
      var ready = !!target.querySelector('[data-form-root], form, iframe, input, button');
      if (ready) localizeFormsToEnglish(target);
      return ready;
    }

    moveFormsIntoModal();
    if (target) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (moveFormsIntoModal() || tries > 20) clearInterval(timer);
      }, 250);
      var observer = new MutationObserver(function () {
        localizeFormsToEnglish(target);
      });
      observer.observe(target, { childList: true, subtree: true });
    }

    function openModal() {
      moveFormsIntoModal();
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });
    closers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function initFaq() {
    var faqData = [
      {
        q: 'Do you have real-life examples of where your machines are used?',
        a: 'Yes. HAHA AI Vending machines are already used in a wide range of locations, including gyms, offices, factories, schools, hotels, convenience stores, and community spaces. Our machines are designed to fit different business environments — from small operators adding their first machine to businesses managing multiple locations.'
      },
      {
        q: 'How does your machine identify products?',
        a: 'HAHA uses AI vision technology to recognize products automatically. When customers open the door and take items, the cameras track the products in real time and automatically complete checkout after the door closes.'
      },
      {
        q: 'How accurate is the AI recognition?',
        a: 'Our AI recognition system achieves up to 99% recognition accuracy through advanced computer vision technology. If an unusual order occurs, operators can easily review and manage it through the operator app.'
      },
      {
        q: 'Is your machine air-cooled or direct-cooled?',
        a: 'Our machines use reliable air-cooling technology designed for stable temperature control and efficient operation. The temperature can also be adjusted remotely through the operator system.'
      },
      {
        q: 'Is your equipment rainproof?',
        a: 'HAHA machines are designed for indoor and protected outdoor environments. For outdoor locations, we recommend using proper shelter or a canopy to protect the equipment from direct rain exposure.'
      },
      {
        q: 'Can your equipment perform age verification?',
        a: 'Currently, HAHA machines do not include built-in age verification. Operators are responsible for complying with local regulations when selling age-restricted products.'
      },
      {
        q: 'Why is pre-authorization required?',
        a: 'Pre-authorization verifies that a valid payment method is available before the door unlocks. After customers finish shopping, they are only charged for the items they actually take.'
      },
      {
        q: 'How do pre-authorization refunds work?',
        a: 'After checkout is completed, the final purchase amount is calculated automatically. Any remaining authorized amount is released back to the customer according to their bank’s processing time.'
      },
      {
        q: 'What payment methods does HAHA support?',
        a: 'HAHA supports major payment methods including credit cards, debit cards, Apple Pay, Google Pay, and other contactless payment options.'
      },
      {
        q: 'How do operators handle payments and taxes?',
        a: 'Payment processing is handled automatically through the integrated payment system. Operators receive their sales revenue through their connected payment account. Tax reporting depends on your business location and local regulations. Operators are responsible for managing applicable taxes based on their own business requirements.'
      },
      {
        q: 'What kind of after-sales support do you provide?',
        a: 'HAHA provides professional customer support throughout your vending journey. Our support team is available 365 days a year, with fast response within 5 minutes and solutions provided within 24 hours for most issues.'
      },
      {
        q: 'Where can I find instructions for using your app?',
        a: 'We provide detailed user guides and operation tutorials to help you quickly learn the HAHA Operator App. Our support team can also provide personalized guidance when needed.'
      },
      {
        q: 'How do I set up an account or activate devices?',
        a: 'After purchase, our team will guide you through account setup, device activation, payment setup, and initial configuration to help you launch smoothly.'
      },
      {
        q: 'How can I contact HAHA Vending?',
        a: 'You can reach our team through phone, WhatsApp, email, or directly from the HAHA Operator App. Phone / WhatsApp: +1 (213) 938-0945. Email: info@hahavendingstore.com. For faster assistance, you can also contact our support team directly through the HAHA Operator App.'
      }
    ];
    var fl = document.getElementById('faqList');
    if (!fl) return;
    faqData.forEach(function (item) {
      var d = document.createElement('div');
      d.className = 'faq__item';
      d.innerHTML =
        '<button type="button" class="faq__q" aria-expanded="false">' +
        item.q +
        '<span class="faq__q-icon">+</span></button><div class="faq__a"><div class="faq__a-inner">' +
        item.a +
        '</div></div>';
      d.querySelector('button').addEventListener('click', function () {
        var io = d.classList.contains('faq__item--open');
        fl.querySelectorAll('.faq__item--open').forEach(function (e) {
          e.classList.remove('faq__item--open');
        });
        fl.querySelectorAll('[aria-expanded="true"]').forEach(function (e) {
          e.setAttribute('aria-expanded', 'false');
        });
        if (!io) {
          d.classList.add('faq__item--open');
          d.querySelector('button').setAttribute('aria-expanded', 'true');
        }
      });
      fl.appendChild(d);
    });
  }

  function pauseScanlineOnScroll() {
    var body = document.body;
    var timer = null;
    window.addEventListener(
      'scroll',
      function () {
        body.classList.add('is-scrolling');
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          body.classList.remove('is-scrolling');
        }, 150);
      },
      { passive: true }
    );
  }

  function initAnimations() {
    gsap.config({ force3D: true });
    ScrollTrigger.config({ ignoreMobileResize: true });
    pauseScanlineOnScroll();

    gsap.fromTo('.all-view__title', { opacity: 0, y: 36 }, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out', delay: 0.1 });
    gsap.fromTo('.family-stage', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.75, ease: 'power3.out', delay: 0.25 });

    function failSafeReveal(selector, y) {
      var els = document.querySelectorAll(selector);
      els.forEach(function (el, i) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 88%',
          once: true,
          onEnter: function () {
            gsap.fromTo(
              el,
              { opacity: 0, y: y || 24 },
              { opacity: 1, y: 0, duration: 0.55, ease: 'power2.out', delay: (i % 5) * 0.04, force3D: true }
            );
          }
        });
      });
    }
    failSafeReveal('#howWorksGrid .how-works__card');
    failSafeReveal('#trustGrid .trust-card');
    failSafeReveal('#pricingDuo .pricing-card');
    failSafeReveal('#featuresGrid .features-grid__item');
    failSafeReveal('#reviewsGrid .review-card');
    failSafeReveal('.reviews-summary');
    failSafeReveal('#directGrid .direct-card');
    failSafeReveal('#appPoints .app-point');

    ScrollTrigger.create({
      trigger: '.cta-full',
      start: 'top 75%',
      once: true,
      onEnter: function () {
        gsap.fromTo('.cta-full__inner', { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.55, ease: 'power2.out' });
      }
    });

    function refreshTriggers() {
      ScrollTrigger.refresh();
    }
    window.addEventListener('load', function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(refreshTriggers);
      });
    });
    setTimeout(refreshTriggers, 400);
  }

  window.hahaLandingShowView = showView;
})();
